export const ATTRACTIONS = "attraction";
export const TOURS = "product";
export const CITIES = "city";
export const NOT_FOUND = "notFound";
